import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import Box from "../Box";
import { HeaderWrapper } from "../../pages/ConfirmBookingStatus";
import ConfirmRequestAccordion from "../../pages/ConfirmBookingStatus/ConfirmRequestAccordion";
import dayjs from "dayjs";
import { isValidUrl } from "../../helper";

const BusinessTripLeaveDetails = ({ data }) => {
  const start = dayjs(data.startDate);
  const end = dayjs(data.expectedReturnDate);

  const getContent = (data) => {
    return (
      <>
        {isValidUrl(data) ? (
          <a href={data}>
            <span>{`Leave attachment`}</span>
          </a>
        ) : (
          "Not Available"
        )}
      </>
    );
    // return column.filter((col) => col.key === 'passportPdf');
  };

  return (
    <>
      <HeaderWrapper>
        <TextFont fontColor={Colors.white} fontSize="1.5rem" fontWeight="600">
          Business Trip Leave Details
        </TextFont>
      </HeaderWrapper>
      <div
        style={{
          padding: "1.2rem",
          boxSizing: "border-box",
          background: Colors.white,
          borderRadius: "1rem",
        }}
      >
        <ColumnWrapper>
          {/* <Item>
            <Header>Leave Type</Header>
            <Value>{data?.name}</Value>
          </Item> */}
          <Item>
            <Header>Start Date</Header>
            <Value>{dayjs(data?.startDate).format("DD MMM YYYY")}</Value>
          </Item>
          <Item>
            <Header>Expected Return Date</Header>
            <Value>
              {dayjs(data?.expectedReturnDate).format("DD MMM YYYY")}
            </Value>
          </Item>
          <Item>
            <Header>Requesting</Header>
            <Value>{end.diff(start, "day")} Days</Value>
          </Item>
          <Item>
            <Header>Status</Header>
            {data.status.toLowerCase() === "approved" ? (
              <Success>{data?.status}</Success>
            ) : data.status.toLowerCase() === "cancelled" ?  <Cancelled>{data?.status}</Cancelled>:(
              <Status>{data?.status}</Status>
            )}
          </Item>
          <Item>
            <Header>Attachment</Header>
            <Value>{getContent(data?.attachmentUrl)}</Value>
          </Item>
          <WideItem>
            <Header>Purpose of Travel</Header>
            <Value>{data?.comment}</Value>
          </WideItem>
        </ColumnWrapper>
      </div>
    </>
  );
};

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Item = styled.div`
  width: 20%;
    @media (max-width: 1024px) {
    width: 33.33%;
  }

  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }

`;

const WideItem = styled.div`
  width: 100%;
`;

const Header = styled.div`
  color: rgb(142, 142, 161);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Value = styled.div`
  color: rgb(34, 36, 44);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

const Status = styled.div`
  color: ${Colors.brandTwo};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

const Success = styled.div`
  color: ${Colors.greenHaze};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

const Cancelled = styled.div`
  color: ${Colors.fieryRed};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export default BusinessTripLeaveDetails;
